export const BOOKCALL_TEMPLATE = String.raw`<link href="https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@300;400;500;600;700;800&display=swap" rel="stylesheet">
<style>
:root {
--beige: #F7F1E8;
--beige-soft: #EFE8DC;
--beige-muted: #E3D9CC;
--brown: #8B6F5E;
--brown-dark: #3D2B1F;
--accent: #C4895A;
--accent-soft: #F0DDD0;
--text: #3D2B1F;
--text-muted: #8A7060;
--white: #FDFAF6;
}
*, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
html { scroll-behavior: smooth; }
body {
background: var(--beige);
color: var(--text);
font-family: 'Plus Jakarta Sans', sans-serif;
font-weight: 400;
line-height: 1.7;
overflow-x: hidden;
}
.hero {
min-height: auto;
display: flex;
flex-direction: column;
align-items: center;
justify-content: center;
text-align: center;
padding: 16px 24px 32px;
background: radial-gradient(ellipse at 50% -10%, #e8d5c0 0%, var(--beige) 65%);
position: relative;
}
.badge {
display: inline-flex;
align-items: center;
gap: 8px;
background: var(--white);
border: 1px solid var(--beige-muted);
border-radius: 100px;
padding: 7px 18px 7px 12px;
font-size: 12px;
font-weight: 500;
color: var(--text-muted);
letter-spacing: 0.3px;
margin-bottom: 16px;
opacity: 0;
animation: fadeUp 0.7s ease forwards 0.2s;
}
.badge-dot {
width: 8px;
height: 8px;
border-radius: 50%;
background: var(--accent);
flex-shrink: 0;
box-shadow: 0 0 0 3px var(--accent-soft);
}
.hero h1 {
font-size: clamp(2.2rem, 5.5vw, 4rem);
font-weight: 800;
line-height: 1.1;
color: var(--brown-dark);
max-width: 760px;
margin-bottom: 20px;
letter-spacing: -1.5px;
opacity: 0;
animation: fadeUp 0.7s ease forwards 0.4s;
}
.hero h1 span { color: var(--accent); }
.hero p.sub {
font-size: 1.05rem;
color: var(--text-muted);
max-width: 500px;
font-weight: 400;
margin-bottom: 0;
opacity: 0;
animation: fadeUp 0.7s ease forwards 0.6s;
}
.video-section {
max-width: 880px;
margin: 0 auto;
padding: 8px 24px 56px;
}
.video-wrap {
position: relative;
width: 100%;
padding-bottom: 56.25%;
border-radius: 20px;
overflow: hidden;
box-shadow:
0 2px 4px rgba(61,43,31,0.04),
0 8px 24px rgba(61,43,31,0.08),
0 32px 80px rgba(61,43,31,0.12);
}
.video-wrap iframe {
position: absolute;
inset: 0;
width: 100%;
height: 100%;
border: none;
}
.video-note {
text-align: center;
margin-top: 20px;
font-size: 0.88rem;
color: var(--text-muted);
font-weight: 400;
}
.video-note strong { color: var(--accent); font-weight: 600; }
.transition-section {
max-width: 640px;
margin: 0 auto;
padding: 20px 24px 64px;
text-align: center;
}
.transition-section p {
font-size: 1.1rem;
color: var(--text-muted);
line-height: 1.8;
}
.transition-section strong {
color: var(--brown-dark);
font-weight: 700;
}
.cta-section {
padding: 0 24px 80px;
}
.cta-card {
max-width: 540px;
margin: 0 auto;
background: var(--brown-dark);
border-radius: 24px;
padding: 52px 48px;
text-align: center;
position: relative;
overflow: hidden;
}
.cta-card h2 {
font-size: clamp(1.5rem, 3.5vw, 2rem);
font-weight: 800;
color: var(--white);
line-height: 1.15;
letter-spacing: -0.5px;
margin-bottom: 12px;
}
.cta-card h2 span { color: var(--accent); }
.cta-card .cta-sub {
font-size: 0.92rem;
color: rgba(253,250,246,0.6);
margin-bottom: 32px;
}
.cta-items {
list-style: none;
margin-bottom: 36px;
text-align: left;
display: flex;
flex-direction: column;
gap: 10px;
}
.cta-items li {
font-size: 0.9rem;
color: rgba(253,250,246,0.85);
display: flex;
gap: 10px;
align-items: flex-start;
font-weight: 400;
}
.cta-items li::before {
content: '·';
color: var(--accent);
flex-shrink: 0;
font-size: 1.4rem;
line-height: 1.3;
}
.btn {
display: block;
background: var(--accent);
color: var(--white);
text-decoration: none;
font-weight: 700;
font-size: 0.92rem;
letter-spacing: 0.3px;
padding: 18px 32px;
border-radius: 100px;
transition: all 0.25s ease;
}
.btn:hover {
background: #d49a6a;
transform: translateY(-2px);
box-shadow: 0 12px 36px rgba(196,137,90,0.4);
}
.btn-sub {
display: block;
font-size: 0.78rem;
color: rgba(253,250,246,0.4);
margin-top: 14px;
}
.qualify {
padding: 0 24px 80px;
}
.qualify-grid {
max-width: 860px;
margin: 0 auto;
display: grid;
grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
gap: 20px;
}
.qualify-box {
border-radius: 20px;
padding: 36px 32px;
border: 1px solid transparent;
}
.qualify-box.yes {
background: #F7F1E8;
border-color: #DDD0C0;
}
.qualify-box.no {
background: #EDE3D5;
border-color: #C9B5A2;
}
.qualify-heading {
font-weight: 700;
font-size: 1rem;
color: var(--brown-dark);
margin-bottom: 22px;
}
.qualify-list {
list-style: none;
display: flex;
flex-direction: column;
gap: 12px;
}
.qualify-list li {
display: flex;
align-items: flex-start;
gap: 12px;
font-size: 0.9rem;
color: var(--text);
line-height: 1.6;
}
.qi {
width: 24px;
height: 24px;
border-radius: 50%;
display: flex;
align-items: center;
justify-content: center;
flex-shrink: 0;
margin-top: 2px;
}
.qualify-box.yes .qi {
background: #E3D9CC;
color: #5C4033;
}
.qualify-box.no .qi {
background: #C9B5A2;
color: #3D2B1F;
}
.qi svg {
width: 13px;
height: 13px;
stroke-width: 2.5;
}
.proof {
padding: 32px 24px 80px;
max-width: 900px;
margin: 0 auto;
}
.proof-header {
text-align: center;
margin-bottom: 44px;
}
.proof-header h2 {
font-size: clamp(1.6rem, 3.5vw, 2.2rem);
font-weight: 800;
color: var(--brown-dark);
letter-spacing: -0.5px;
line-height: 1.2;
}
.proof-header h2 span { color: var(--accent); }
.proof-header p {
margin-top: 12px;
color: var(--text-muted);
font-size: 0.95rem;
}
.testimonials {
display: grid;
grid-template-columns: repeat(2, 1fr);
gap: 20px;
}
@media (max-width: 600px) {
.testimonials { grid-template-columns: 1fr; }
}
.testi {
background: var(--white);
border-radius: 20px;
padding: 32px 28px;
border: 1px solid var(--beige-soft);
transition: transform 0.3s ease, box-shadow 0.3s ease;
}
.testi:hover {
transform: translateY(-4px);
box-shadow: 0 16px 48px rgba(61,43,31,0.08);
}
.stars {
font-size: 0.9rem;
margin-bottom: 16px;
color: var(--accent);
letter-spacing: 2px;
}
.testi-text {
font-size: 0.95rem;
color: var(--text);
line-height: 1.7;
margin-bottom: 24px;
font-weight: 400;
}
.testi-author {
display: flex;
align-items: center;
gap: 12px;
padding-top: 20px;
border-top: 1px solid var(--beige-soft);
}
.testi-avatar {
width: 40px;
height: 40px;
border-radius: 50%;
background: var(--accent-soft);
display: flex;
align-items: center;
justify-content: center;
font-size: 1rem;
font-weight: 700;
color: var(--accent);
flex-shrink: 0;
}
.testi-name {
font-weight: 700;
font-size: 0.88rem;
color: var(--brown-dark);
}
.testi-job {
font-size: 0.8rem;
color: var(--text-muted);
margin-top: 2px;
}
footer {
text-align: center;
padding: 36px 24px;
border-top: 1px solid var(--beige-muted);
font-size: 0.82rem;
color: var(--text-muted);
}
@keyframes fadeUp {
from { opacity: 0; transform: translateY(18px); }
to { opacity: 1; transform: translateY(0); }
}
.reveal {
opacity: 0;
transform: translateY(28px);
transition: opacity 0.7s ease, transform 0.7s ease;
}
.reveal.visible {
opacity: 1;
transform: translateY(0);
}
@media (max-width: 600px) {
.cta-card { padding: 40px 28px; }
}
</style>
<!-- ═══════════════════════════════
HERO
[BADGE] = ex : Formation gratuite · Prénom Nom
[TITRE DÉBUT] = ex : Comment attirer tes premières clientes
[MOT CLÉ EN COULEUR] = ex : sans te brader
[TITRE SUITE] = ex : même si tu pars de zéro
[SOUS-TITRE] = ex : Une masterclass de 35 minutes pour comprendre pourquoi ta visibilité ne se transforme pas encore en revenus
═══════════════════════════════ -->
<section class="hero">
<div class="badge">
<span class="badge-dot"></span>
Formation gratuite · Prénom Nom
</div>
<h1>Comment attirer tes premières clientes <span>sans te brader</span>, même si tu pars de zéro</h1>
<p class="sub">Une masterclass de 35 minutes pour comprendre pourquoi ta visibilité ne se transforme pas encore en revenus</p>
</section>
<!-- ═══════════════════════════════
VIDÉO
[LIEN_YOUTUBE] = colle ton lien YouTube normal ici
ex : https://www.youtube.com/watch?v=rSNj-0ONONo
═══════════════════════════════ -->
<section class="video-section reveal" id="video">
<div class="video-wrap">
<iframe
id="yt-frame"
title="Masterclass gratuite"
allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
allowfullscreen>
</iframe>
</div>
<p class="video-note"><strong>Prends de quoi noter.</strong> Il y a des choses que tu vas vouloir garder.</p>
</section>
<!-- ═══════════════════════════════
TRANSITION
[TEXTE TRANSITION] = ex : Cette masterclass te donne la vision globale...
Entoure les mots importants de <strong></strong>
═══════════════════════════════ -->
<section class="transition-section reveal">
<p>Cette masterclass te donne la <strong>vision globale</strong>. Mais ta situation à toi est unique. Si tu veux qu'on analyse ensemble ce qui bloque spécifiquement chez toi et qu'on construise <strong>un plan concret</strong>, c'est ce qu'on fait lors de l'appel.</p>
</section>
<!-- ═══════════════════════════════
CTA / CALENDLY
[TITRE CTA] = ex : Réserve ton
[MOT ACCENT] = ex : appel clarté
[SOUS-TITRE CTA] = ex : 30 minutes pour repartir avec un plan fait pour toi
[ITEM 1/2/3] = les 3 promesses de l'appel
[LIEN_CALENDLY] = ex : https://calendly.com/ton-lien
[TEXTE BOUTON] = ex : Je réserve mon appel gratuit
[SOUS-TEXTE] = ex : Gratuit · Sans engagement · Places limitées
═══════════════════════════════ -->
<section class="cta-section reveal">
<div class="cta-card">
<h2>Réserve ton <span>appel clarté</span> gratuit</h2>
<p class="cta-sub">30 minutes pour repartir avec un plan fait pour toi</p>
<ul class="cta-items">
<li>On analyse ensemble où tu en es et ce qui te freine vraiment</li>
<li>Je t'indique les 2 ou 3 leviers à activer en priorité dans ton cas</li>
<li>Tu repars avec un plan clair, que tu travailles avec moi ou non</li>
</ul>
<a href="https://calendly.com/ton-lien" target="_blank" class="btn">Je réserve mon appel gratuit</a>
<span class="btn-sub">Gratuit · Sans engagement · Places limitées</span>
</div>
</section>
<!-- ═══════════════════════════════
QUALIFICATION
[ITEM OUI 1/2/3/4] = situations où l'appel est pertinent
[ITEM NON 1/2/3] = situations où l'appel n'est pas adapté
═══════════════════════════════ -->
<section class="qualify reveal">
<div class="qualify-grid">
<div class="qualify-box yes">
  <div class="qualify-heading">Cet appel est fait pour toi si…</div>
  <ul class="qualify-list">
    <li>
      <span class="qi"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg></span>
      <span>Tu proposes un accompagnement mais tu peines à attirer des clientes régulièrement</span>
    </li>
    <li>
      <span class="qi"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg></span>
      <span>Tu publies du contenu sans que ça se transforme vraiment en ventes</span>
    </li>
    <li>
      <span class="qi"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg></span>
      <span>Tu sens que ton offre a de la valeur mais tu ne sais pas comment la communiquer</span>
    </li>
    <li>
      <span class="qi"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg></span>
      <span>Tu es prête à investir sérieusement dans ta situation</span>
    </li>
  </ul>
</div>

<div class="qualify-box no">
  <div class="qualify-heading">Ce n'est pas pour toi si…</div>
  <ul class="qualify-list">
    <li>
      <span class="qi"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg></span>
      <span>Tu cherches une solution rapide sans remettre en question ta façon de faire</span>
    </li>
    <li>
      <span class="qi"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg></span>
      <span>Tu n'as pas encore d'offre définie ou de projet concret</span>
    </li>
    <li>
      <span class="qi"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg></span>
      <span>Tu n'es pas disponible pour t'investir dans un suivi sur la durée</span>
    </li>
  </ul>
</div>

</div>
</section>
<!-- ═══════════════════════════════
TÉMOIGNAGES
[TITRE PROOF] = ex : Elles l'ont déjà fait
[SOUS-TITRE PROOF] = ex : Des femmes qui étaient exactement là où tu en es aujourd'hui
Pour chaque témoignage :
[TÉMOIGNAGE] = le texte entre guillemets
[INITIALE] = première lettre du prénom (remplace C, L, S, M)
[NOM] = ex : Camille R.
[RÉSULTAT] = ex : Coach bien-être · +3 clientes en 30 jours
═══════════════════════════════ -->
<section class="proof reveal">
<div class="proof-header">
<h2>Elles l'ont <span>déjà fait</span></h2>
<p>Des femmes qui étaient exactement là où tu en es aujourd'hui</p>
</div>
<div class="testimonials">
<div class="testi">
  <div class="stars">★★★★★</div>
  <p class="testi-text">"Je cherchais des clientes depuis 8 mois. Après notre appel, j'ai eu ma première cliente high ticket en 3 semaines."</p>
  <div class="testi-author">
    <div class="testi-avatar">C</div>
    <div>
      <div class="testi-name">Camille R.</div>
      <div class="testi-job">Coach bien-être · +3 clientes en 30 jours</div>
    </div>
  </div>
</div>

<div class="testi">
  <div class="stars">★★★★★</div>
  <p class="testi-text">"J'avais peur de paraître trop chère. Maintenant je vends à 1500€ et mes clientes sont ravies."</p>
  <div class="testi-author">
    <div class="testi-avatar">L</div>
    <div>
      <div class="testi-name">Laura M.</div>
      <div class="testi-job">Consultante RH · offre passée de 300€ à 1500€</div>
    </div>
  </div>
</div>

<div class="testi">
  <div class="stars">★★★★★</div>
  <p class="testi-text">"La clarté que j'ai eue en 45 minutes m'a évité des mois d'essais ratés."</p>
  <div class="testi-author">
    <div class="testi-avatar">S</div>
    <div>
      <div class="testi-name">Sophie D.</div>
      <div class="testi-job">Formatrice · 5k€ de CA le mois suivant</div>
    </div>
  </div>
</div>

<div class="testi">
  <div class="stars">★★★★★</div>
  <p class="testi-text">"Je n'osais pas me lancer. Après cet appel j'avais enfin un plan concret et la confiance pour y aller."</p>
  <div class="testi-author">
    <div class="testi-avatar">M</div>
    <div>
      <div class="testi-name">Marie L.</div>
      <div class="testi-job">Thérapeute · première cliente signée en 2 semaines</div>
    </div>
  </div>
</div>

</div>
</section>
<!-- ═══════════════════════════════
FOOTER
[ANNÉE] = ex : 2025
[NOM DE LA COACH] = ex : Prénom Nom
═══════════════════════════════ -->
<footer>
<p>© 2025 Prénom Nom — Tous droits réservés</p>
</footer>
<script>
// ═══════════════════════════════
// [LIEN_YOUTUBE] = colle ton lien YouTube ici
// ex : https://www.youtube.com/watch?v=rSNj-0ONONo
// ═══════════════════════════════
const youtubeUrl = "https://www.youtube.com/watch?v=rSNj-0ONONo";
const match = youtubeUrl.match(/(?:v=|youtu\.be\/)([a-zA-Z0-9_-]{11})/);
if (match) {
document.getElementById('yt-frame').src = "https://www.youtube.com/embed/" + match[1];
}
const reveals = document.querySelectorAll('.reveal');
const observer = new IntersectionObserver((entries) => {
entries.forEach(e => {
if (e.isIntersecting) {
e.target.classList.add('visible');
observer.unobserve(e.target);
}
});
}, { threshold: 0.1 });
reveals.forEach(r => observer.observe(r));
</script>`;

const PROMPT_REDACTION = `Tu es un expert en copywriting pour pages de capture et pages VSL. Je vais te donner mes réponses à un questionnaire et mon document de client cible. Ton rôle est de générer les textes de ma page en plusieurs versions pour que je puisse choisir et combiner.
Pour chaque élément, génère 3 propositions, du plus direct au plus émotionnel. Adapte le ton selon le type de vidéo décrit : courte vidéo de chauffe = textes courts et directs / masterclass longue = textes plus développés.
Structure de sortie :
LABEL — 3 propositions
TITRE — 3 propositions (indique pour chacun quelle partie mettre en couleur)
SOUS-TITRE — 2 propositions
NOTE SOUS VIDÉO — 2 propositions
TEXTE DE TRANSITION — 2 propositions
CTA TITRE — 2 propositions
CTA SOUS-TITRE — 2 propositions
CTA BULLETS (3 bullets) — 1 version
CTA BOUTON — 3 propositions
CTA SOUS-TEXTE — 2 propositions
QUALIFICATION OUI (4 items) — 1 version
QUALIFICATION NON (3 items) — 1 version
TÉMOIGNAGES — reformule les témoignages bruts fournis / sinon écris "aucun témoignage fourni"
Voici mes réponses, le code de la page, et mon document cible :`;

const PROMPT_DESIGN = `Tu vas modifier le code HTML que je te fournis en appliquant les textes que j'ai générés à l'étape précédente et les préférences design ci-dessous. Remplace tous les textes du template par ceux fournis. Applique les couleurs, la police et les préférences de style indiquées. Si une police Google Fonts est demandée, remplace le lien d'import en haut du code. Si "pas de témoignages" est indiqué, supprime entièrement la section témoignages du code. Ne touche à aucune structure HTML, aucune classe CSS, aucune logique JavaScript en dehors de ce qui est demandé. Retourne uniquement le code complet modifié, sans explication, sans commentaire.
Voici mes préférences design, mes textes finalisés, et le code du template :`;

const Q = (id, label, hint, answers = 1) => ({ t: "question", id, label, hint, answers });

const blockText = (b) => {
  switch (b.t) {
    case "question": return `${b.id}. ${b.label}${b.hint ? ` ${b.hint}` : ""}\n${b.answers > 1 ? Array.from({ length: b.answers }, (_, i) => `→ ${i + 1}.`).join("\n") : "→ ..."}`;
    case "copy": return b.text;
    case "code": return `${b.label}\n${b.hint}\n${b.text}`;
    case "bullets": return b.items.map((x) => `- ${x}`).join("\n");
    case "steps": return b.items.map((x, i) => typeof x === "string" ? `${i + 1}. ${x}` : `${i + 1}. ${x.text}\n${x.sub.map((s) => `   - ${s}`).join("\n")}`).join("\n");
    case "link": return `${b.before} ${b.href}`;
    case "video": return `${b.before ? `${b.before} ` : ""}${b.href}`;
    default: return b.text;
  }
};

export const chapterText = (c) => [
  `${c.emoji} ${c.kicker} 👉🏻 ${c.title}`,
  c.intro,
  ...c.steps.map((s) => [`${s.num} ${s.title}`, ...s.blocks.map(blockText)].join("\n\n")),
].filter(Boolean).join("\n\n");

export const BOOKCALL_PAGE = {
  title: "Tutoriel : Comment créer ta page book a call (étape par étape)",
  subtitle: "(En 1H top chrono ⏱️)",
  exampleIntro: "Petit exemple de ce que tu vas pouvoir créer POUR TOI :",
  exampleImage: "/book-call-example.webp",
  chapters: [
    {
      emoji: "1️⃣",
      kicker: "Commence ICI",
      title: "Rédaction de la Page",
      steps: [
        {
          num: "1️⃣",
          title: "ÉTAPE N°1 - LE QUESTIONNAIRE",
          blocks: [
            { t: "p", text: "Réponds au questionnaire suivant. Plus tu donnes de matière, mieux c'est. Ne te censure pas, n'essaie pas de faire propre. Tu peux répondre en vrac, coller des bouts de phrases, des idées en désordre, des messages que tu as déjà envoyés à des clientes, des retours que tu as reçus. L'IA fait le tri et la mise en forme, pas toi." },
            Q("A1", "Qui es-tu et ce que tu fais", "(Ex : Je suis coach business pour femmes entrepreneures, je les aide à structurer leur offre et à trouver leurs premières clientes.)"),
            Q("A2", "Ta cible", "(Si tu as un document avatar client, tu le joindras directement à l'IA à l'étape suivante. Sinon, décris ici qui est cette personne, ce qu'elle veut, ce qui la bloque, ses peurs, ses objections, ce qu'elle a déjà essayé. Plus c'est détaillé, mieux c'est.)"),
            Q("B1", "C'est quoi cette vidéo ?", "(Ex : Une courte vidéo de 3 minutes juste avant le bouton de réservation / Une masterclass gratuite de 35 minutes sur...)"),
            Q("B2", "Quel est le sujet exact de la vidéo ?", "(Ex : Pourquoi ta visibilité ne se transforme pas en revenus / Les 3 raisons pour lesquelles les jeunes adultes sont stressés en 2026 et comment y remédier)"),
            Q("B3", "Durée approximative", ""),
            Q("B4", "Quel est le résultat ou la prise de conscience principale que la personne repart avec après avoir regardé la vidéo ?", "(Ex : Elle comprend enfin pourquoi ça ne convertit pas / Elle identifie son vrai problème de positionnement)"),
            Q("C1", "Comment tu appelles cet appel ?", "(Ex : Appel clarté / Session stratégie / Bilan offert)"),
            Q("C2", "Durée de l'appel", ""),
            Q("C3", "Ce qui se passe concrètement pendant l'appel — les 3 choses principales", "", 3),
            Q("C4", "C'est quoi le vrai objectif de cet appel ?", "(Ex : Complètement offert sans pitch / Offert mais je présente mon offre si c'est pertinent / C'est un appel de vente assumé)"),
            Q("C5", "Pour qui cet appel est VRAIMENT fait ?", "(Ex : Pour une coach qui a déjà une offre mais zéro système pour la vendre)"),
            Q("C6", "Pour qui cet appel n'est PAS adapté ?", "(Ex : Quelqu'un qui n'a pas encore d'offre / Quelqu'un qui cherche juste des tactiques rapides)"),
            Q("C7", "As-tu des témoignages clients ?", "(Si oui, colle-les ici peu importe le format : messages WhatsApp recopiés, DMs Instagram, avis Google, retours oraux que tu as retranscrits. L'IA les reformatera.)"),
            Q("C8", "Y a-t-il autre chose que tu veux qu'on sache ?", "(Ton histoire, pourquoi tu fais ça, ce qui rend ton approche différente, des phrases que tu utilises souvent avec tes clientes, des retours qu'on t'a déjà faits... Tout ce qui peut aider l'IA à écrire avec ta voix.)"),
          ],
        },
        {
          num: "2️⃣",
          title: "ÉTAPE N°2 - UNE FOIS LE QUESTIONNAIRE REMPLI",
          blocks: [
            { t: "h", text: "1. Ouvre Claude (claude.ai) ou ChatGPT" },
            { t: "tip", text: "💡 Recommandation : Claude.ai car meilleure rédaction" },
            { t: "h", text: "2. Dans la zone de message, colle dans cet ordre" },
            { t: "p", text: "D'abord ce prompt d'instruction :" },
            { t: "copy", label: "Prompt d'instruction", text: PROMPT_REDACTION },
            { t: "p", text: "Puis juste en dessous, dans le même message :" },
            { t: "bullets", items: ["Tes réponses au questionnaire", "Ton document de client cible (qu’on a créé au début de l’accompagnement)"] },
            { t: "p", text: "Puis envoie." },
          ],
        },
        {
          num: "3️⃣",
          title: "ÉTAPE N°3 - LIS LES PROPOSITIONS ET FINALISE LA RÉDACTION AVEC L’IA",
          blocks: [
            { t: "p", text: "Dis-lui ce que tu veux ajuster, modifier, supprimer ou reformuler." },
            { t: "p", text: "Réponds dans le même fil, aussi longtemps que nécessaire, jusqu'à ce que tu sois satisfaite de chaque texte." },
            { t: "example", text: "(Ex : \"Le titre 2 est trop long, raccourcis-le\" / \"La note sous la vidéo sonne trop commercial, rends-la plus naturelle\" / \"Propose-moi 3 autres versions du label\")" },
            { t: "p", strong: true, text: "Une fois que tu es satisfaite de tous les textes, passe au Chapitre 2 : Le Design de la page." },
          ],
        },
      ],
    },
    {
      emoji: "2️⃣",
      kicker: "La Rédaction est finie ?",
      title: "Design de la Page",
      steps: [
        {
          num: "1️⃣",
          title: "ÉTAPE N°1 - Remplis le questionnaire design",
          blocks: [
            Q("D1", "Quelles sont tes polices d’écriture ?", "(Ex : Cormorant Garamond, DM Sans, Nunito, Raleway. Si tu n'en as pas, laisse vide et l'IA gardera celle du modèle.)"),
            Q("D2", "Quelles sont tes couleurs ?", "(Donne les codes hex si tu les as. Ex : fond #F4EEE8 / couleur principale #B87333 / texte #2E1F14. Si tu n'en as pas, laisse vide.)"),
            Q("D3", "Le lien de ta vidéo YouTube", "(Colle le lien complet. Ex : https://www.youtube.com/watch?v=XXXXXXXXXX)"),
            Q("D4", "Le lien de ton Calendly", "(Colle le lien complet. Ex : https://calendly.com/ton-prenom/appel-clarte)"),
            Q("D5", "As-tu des témoignages à afficher sur la page ?", "(Si non, écris \"non\" et l'IA supprimera cette section automatiquement.)"),
            Q("D6", "Des préférences sur le style général de la page ?", "(Ex : Je veux quelque chose d'épuré et minimaliste / Je veux quelque chose de plus chaleureux et féminin / Je veux garder le style du modèle tel quel / Je veux des arrondis plus marqués / Je veux une ambiance plus sombre et premium)"),
          ],
        },
        {
          num: "2️⃣",
          title: "ÉTAPE N°2 - Génère le code du design avec l'IA",
          blocks: [
            { t: "h", text: "1. Ouvre une nouvelle conversation dans Claude ou ChatGPT (pas la même que la rédaction)" },
            { t: "h", text: "2. Colle dans cet ordre dans le même message" },
            { t: "p", text: "D'abord ce prompt d'instruction :" },
            { t: "copy", label: "Prompt d'instruction", text: PROMPT_DESIGN },
            { t: "p", text: "Puis juste en dessous, dans le même message :" },
            { t: "bullets", items: ["Tes réponses au questionnaire design ci-dessus", "Les textes finalisés que tu as générés au Chapitre 1", "Le code HTML du template ci-dessous"] },
            { t: "code", label: "CODE DESIGN À ENVOYER À L’IA", hint: "Copie / Colle le code", text: BOOKCALL_TEMPLATE },
            { t: "h", text: "3. Envoie" },
            { t: "p", text: "L'IA te retourne le code complet de ta page personnalisée. Copie-le intégralement, tu en auras besoin au Chapitre 3." },
          ],
        },
      ],
    },
    {
      emoji: "3️⃣",
      kicker: "C’est BIENTÔT fini",
      title: "Mise en Place",
      steps: [
        {
          num: "1️⃣",
          title: "ÉTAPE N°1 - Importer la page sur Systeme.io",
          blocks: [
            { t: "tip", italic: true, text: "💡 Systeme.io est un outil tout-en-un qui permet de créer des pages web, des tunnels de vente et d'envoyer des emails, sans aucune compétence technique. C'est l'outil qu'on utilise ici pour mettre ta page en ligne. Il a un plan gratuit qui suffit largement pour démarrer." },
            { t: "link", before: "Clique sur ce lien :", href: "https://systeme.io/dashboard/share?hash=7113475ceae11161097db0eae230a366cb7ed94&type=funnel", label: "Importer le modèle sur Systeme.io" },
            { t: "p", text: "✅ Si tu es connectée à ton compte Systeme.io, le modèle s'importe automatiquement dans ton espace." },
            { t: "link", before: "❌ Si tu n'as pas encore de compte, tu peux en créer un gratuitement ici :", href: "https://systeme.io/fr?sa=sa00550542923850d03613958aee7d14058cfe0211", label: "Créer mon compte Systeme.io" },
          ],
        },
        {
          num: "2️⃣",
          title: "ÉTAPE N°2 - Créer TA page",
          blocks: [
            { t: "steps", items: [
              "Dans le menu en haut, ouvre le menu déroulant \"Sites\" puis clique sur \"Tunnels de vente\"",
              "Repère le tunnel \"TEMPLATE - BOOK A CALL\" et clique sur son nom",
              "Clique sur la page \"Page Book A Call\" puis sur \"Modifier la page\"",
              "Une fois dans l'éditeur, passe ta souris sur la page beige jusqu'à voir apparaître un contour orange, puis clique dessus",
              "Dans le menu à gauche, clique sur le bouton bleu \"Modifier le code\"",
              { text: "Une fenêtre s'ouvre avec du code :", sub: ["Sélectionne tout (Ctrl+A sur Windows / Cmd+A sur Mac)", "Supprime tout", "Colle ton code généré au Chapitre 2", "Clique sur \"Enregistrer\""] },
              "En haut à droite, clique sur \"Sauvegarder\" puis sur \"Sortir\"",
            ] },
          ],
        },
        {
          num: "3️⃣",
          title: "ÉTAPE N°3 - Personnaliser l'URL de ta page",
          blocks: [
            { t: "p", text: "De retour dans les pages du tunnel, tu vas voir une suite de lettres et chiffres dans le champ \"Chemin de l'URL\" du style aca442c5." },
            { t: "p", text: "Tu peux remplacer ça par ce que tu veux. Par exemple : formation-gratuite, masterclass-offerte, ou ton prénom + le nom de ta formation." },
            { t: "done", text: "Ta page est 100% prête." },
          ],
        },
      ],
    },
    {
      emoji: "4️⃣",
      kicker: "Promis, c’est FINI !",
      title: "Derniers Détails",
      intro: "⚠️ Ce chapitre est optionnel. Ta page fonctionne très bien sans. Mais si tu veux aller un cran plus loin et donner une image vraiment professionnelle, voici deux petites choses qui font une vraie différence.",
      steps: [
        {
          num: "1️⃣",
          title: "ÉTAPE N°1 - Nom de Domaine",
          blocks: [
            { t: "tip", text: "💡 Un nom de domaine, c'est tout simplement l'adresse de ton site.\nSans ça, ta page sera accessible via une URL du style prenom.systeme.io/ta-page ce qui fonctionne, mais ça se voit que c'est un outil tiers. Avec ton propre domaine, tu obtiens quelque chose comme\n“www.growithfanny.fr/formation-gratuite” C'est plus crédible, plus mémorisable, et ça renforce ta marque à chaque fois que quelqu'un voit ton lien." },
            { t: "h", text: "Tu n'as pas encore de nom de domaine ?" },
            { t: "link", before: "Tu peux en acheter un sur Hostinger, c'est le moins cher du marché et l'interface est simple. Compte environ 8-12€ par an :", href: "https://www.hostinger.fr", label: "www.hostinger.fr" },
            { t: "h", text: "Une fois ton domaine acheté, voici comment le connecter à Systeme.io :" },
            { t: "steps", items: [
              "Clique sur ta photo de profil en haut à droite, puis sur \"Paramètres\"",
              "Dans le menu, clique sur \"Domaines personnalisés\"",
              "Clique sur le bouton bleu \"Ajouter un domaine\"",
              "Entre ton domaine en commençant par www (ex : www.tondomaine.com) et clique sur \"Enregistrer\"",
              "Une fenêtre s'ouvre avec deux enregistrements CNAME — ne ferme pas cette fenêtre",
              "Connecte-toi à ton compte Hostinger (ou autre registrar), va dans les paramètres DNS de ton domaine, et ajoute les deux CNAME exactement comme indiqué par Systeme.io",
              "Une fois les CNAME ajoutés, la connexion se fait automatiquement en quelques minutes à quelques heures",
            ] },
            { t: "video", before: "Pour un tuto vidéo :", href: "https://www.youtube.com/watch?v=crfxWjeSxQg" },
          ],
        },
        {
          num: "2️⃣",
          title: "ÉTAPE N°2 - Favicon Personnalisée",
          blocks: [
            { t: "tip", text: "💡 La favicon c'est la petite icône qui apparaît dans l'onglet du navigateur quand quelqu'un ouvre ta page. Par défaut c'est le logo de Systeme.io. En la remplaçant par ton logo ou tes initiales, ta page a l'air d'un vrai site professionnel." },
            { t: "h", text: "Créer ta favicon :" },
            { t: "p", text: "Rends-toi sur Canva (gratuit), crée un nouveau projet de 128 x 128 px, et place ton logo ou tes initiales dessus avec tes couleurs. Télécharge l'image en PNG." },
            { t: "h", text: "L'ajouter sur Systeme.io :" },
            { t: "steps", items: [
              "Clique sur ta photo de profil, puis \"Paramètres\"",
              "Clique sur \"Domaines personnalisés\"",
              "Clique sur les 3 points à côté de ton domaine, puis sur \"Paramètres\"",
              "Clique sur \"Sélectionner une image\" et importe ton fichier (max 64px de large)",
              "Clique sur \"Sauvegarder\"",
            ] },
            { t: "p", text: "Ta favicon apparaîtra désormais sur toutes tes pages liées à ce domaine." },
            { t: "video", href: "https://www.youtube.com/watch?v=GPW9LC6f3sA" },
          ],
        },
      ],
    },
  ],
};
